import _ from 'lodash';
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';
import {AxiosResponse} from 'axios';
import BioProfileService from '../../services/bioProfileService';
import BioProfileMuleService from '../../services/bioProfileMuleService';
import {BioProfileModuleConstant, UrlModuleConstant} from '../../constants';
import Save from './save.html';
import BioAdmin from 'types/ba/bioAdmin';

interface IComponentData {
	error: boolean;
	isSubmittedInvalid: boolean;
	isSubmittedValid: boolean;
	useSpringApi: boolean;
}

const bioProfileService: BioAdmin.IBioProfileService = new BioProfileService();
const bioProfileMuleService: BioAdmin.IBioProfileService = new BioProfileMuleService();

export default Vue.component('save', {
	props: ['isInvalid', 'loading'],
	template: Save,
	data(): IComponentData {
		return {
			error: false,
			isSubmittedInvalid: false,
			isSubmittedValid: false,
			useSpringApi: false,
		};
	},
	computed: {
		...mapState(BioProfileModuleConstant.name, ['bioProfile']),
		...mapGetters(UrlModuleConstant.name, ['getGlobalPageDriverUrl']),
	},
	methods: {
		saveProfile() {
			if(!this.isInvalid){
				const featureFlags = window.lt.features;
				if(featureFlags) {
					const feature = featureFlags[featureFlags.findIndex( (x: any) => x.featureId === 'biosSpringApi')];
					if(feature && feature.enabled)
					this.useSpringApi = true;
				}
				this.isSubmittedValid = true;
				if (this.useSpringApi) {
					return bioProfileService.setBioProfile(this.bioProfile)
						.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
							if (response.data.status === 'success') {
								window.location.assign(this.getGlobalPageDriverUrl('biosAdmin', 'manageProfile'));
							} else {
								this.error = true;
							}
					});
				} else {
					return bioProfileMuleService.setBioProfile(this.bioProfile)
						.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
							if (response.data.status === 'success') {
								window.location.assign(this.getGlobalPageDriverUrl('biosAdmin', 'manageProfile'));
							} else {
								this.error = true;
							}
					});
				}
			} else {
				this.isSubmittedInvalid = true;
			}
		},
		cancel() {
			window.location.assign(this.getGlobalPageDriverUrl('biosAdmin', 'manageProfile'));
		},
	},
	watch: {

	},
});
